import { faculties as defaultFaculties } from './facultyData';

const normalizeProducts = (faculty, products) => {
  const normalized = Array.isArray(products)
    ? products
        .filter((product) => product && product.id && product.title)
        .filter((product) => {
          const id = String(product.id || '').toLowerCase();
          const title = String(product.title || '').toLowerCase();
          const isLegacyMockId =
            id.endsWith('-book-starter') || id.endsWith('-course-toolkit');
          const isLegacyMockTitle =
            title.includes('starter book') || title.includes('course toolkit');
          return !(isLegacyMockId || isLegacyMockTitle);
        })
        .map((product) => ({
          id: String(product.id),
          title: product.title || '',
          type: product.type || 'book',
          description: product.description || '',
          image: product.image || faculty.logo || '/School Of SHEM Welcome.png',
          price: Number(product.price) || 0,
          format: product.format || 'physical',
          pdfUrl: product.pdfUrl || '',
          pdfFileName: product.pdfFileName || '',
          videoUrl: product.videoUrl || '',
          videoFileName: product.videoFileName || ''
        }))
    : [];

  return normalized;
};

export const normalizeFacultiesContent = (source = []) => {
  if (!Array.isArray(source) || source.length === 0) {
    return defaultFaculties.map((faculty) => ({
      ...faculty,
      products: normalizeProducts(faculty, faculty.products)
    }));
  }
  const sourceWithFamilyEconomy = source.some((item) => item?.slug === 'building-a-family-economy')
    ? source
    : [...source, defaultFaculties.find((item) => item.slug === 'building-a-family-economy')].filter(Boolean);

  return sourceWithFamilyEconomy
    .filter((item) => item && item.slug)
    .map((item) => {
      const defaults = defaultFaculties.find((faculty) => faculty.slug === item.slug);
      const isMastersOfEconomy = item.slug === 'masters-of-the-economy';
      const faculty = {
        slug: item.slug,
        title: item.title || '',
        summary: item.summary || '',
        logo: item.logo || '/School Of SHEM Welcome.png',
        details: {
          overview: isMastersOfEconomy
            ? defaults?.details?.overview
            : (item.details?.overview || defaults?.details?.overview || ''),
          highlights: isMastersOfEconomy
            ? (defaults?.details?.highlights || [])
            : (Array.isArray(item.details?.highlights) ? item.details.highlights : (defaults?.details?.highlights || [])),
          learning: Array.isArray(item.details?.learning)
            ? item.details.learning
            : (defaults?.details?.learning || []),
          outcomes: Array.isArray(item.details?.outcomes)
            ? item.details.outcomes
            : (defaults?.details?.outcomes || []),
          outcome: item.details?.outcome || defaults?.details?.outcome || ''
        }
      };
      return {
        ...faculty,
        products: normalizeProducts(faculty, item.products)
      };
    });
};
